import { render, staticRenderFns } from "./modify-password.vue?vue&type=template&id=06a376ea&scoped=true"
import script from "./modify-password.vue?vue&type=script&lang=js"
export * from "./modify-password.vue?vue&type=script&lang=js"
import style0 from "./modify-password.vue?vue&type=style&index=0&id=06a376ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06a376ea",
  null
  
)

export default component.exports